import React, {Component} from 'react'
import 'firebase/firestore'
import firebase from '../lib/Config'
import imageResponsive from '../img/nosotros//welcomeBg_responsive.jpg'
import imagePrincipal from '../img/nosotros/01.jpg'
import imageAboutUs from '../img/nosotros/a-01.jpg'
import bgbox1 from '../img/nosotros/bgbox1.jpg'
import bglogo from '../img/nosotros/s.png'
import bgbox2 from '../img/nosotros/hotel.png'
import Social from '../componentes/Social'
import Parallax from 'react-rellax'
import Slider from "react-slick"
import IconArrow from '../icons/IconArrow'
import { Link } from 'react-router-dom'
import Footer from '../componentes/Footer'

class Nosotros extends Component{
	_isMounted = false;
	constructor(props) {
		super(props);
		this.ref_rooms = firebase.firestore().collection("rooms").orderBy("order", "asc")
        this.ref_services = firebase.firestore().collection("services")
		this.unsubscribe_rooms = null
		this.unsubscribe_services = null
		this.state = {
			rooms: [],
			services: [],
            typeMoney: 'S/ ',
			bgBanner: imagePrincipal,
			aboutus_img: imageAboutUs,
			bgbox1: bgbox1,
			bgbox2: bgbox2,
			bglogo: bglogo
		};
	}

	//https://www.behance.net/gallery/63922665/The-Scott-Hotel-Resort-Spa?tracking_source=search%7Cresort
	//https://www.behance.net/gallery/82469309/YurtlarBurada-Website?tracking_source=search%7Chotel
	//https://www.behance.net/gallery/81923757/SPA-Booking?tracking_source=search%7Chotel

    onCollectionUpdateRooms = (querySnapshot) => {
        const rooms = []
        querySnapshot.forEach((doc) => {
            rooms.push(
                Object.assign({
                    id: doc.id
                }, doc.data())
            )
        });
        this.setState({
            rooms
        });
	}  
	
	onCollectionUpdateServices = (querySnapshot) => {
        const services = []
        querySnapshot.forEach((doc) => {
            services.push(
                Object.assign({
                    id: doc.id
                }, doc.data())
            )
        });
        this.setState({
            services
        });
	}  

	getInitialElementView(){
		var elementsToShow = document.querySelectorAll('.is-visible');
		Array.prototype.forEach.call(elementsToShow, function(element){
			var param = element.querySelectorAll('.lazy');
			for (let i=0; i < param.length; i++) {
				if( param[i].getAttribute('data-src') ){
					param[i].setAttribute('src',param[i].getAttribute('data-src'));
					param[i].removeAttribute('data-src');
				}
			}
		});
	}
	scrollIt(element) {  
		window.scrollTo({
			'behavior': 'smooth',
			'left': 0,
			'top': element.offsetTop
		});
	}

	getElementInView(){
		var scroll = window.requestAnimationFrame || function(callback){ window.setTimeout(callback, 1000/60)};
		var elementsToShow = document.querySelectorAll('.show-on-scroll'); 

		function loop() {
			Array.prototype.forEach.call(elementsToShow, function(element){
				var param = element.querySelectorAll('.lazy');
				for (let i=0; i < param.length; i++) {
					if( param[i].getAttribute('data-src') ){
						if ( isElementInViewport(element) ) {
							element.classList.add('is-visible');
							param[i].setAttribute('src',param[i].getAttribute('data-src'));
							param[i].removeAttribute('data-src');
						} else {
							element.classList.remove('is-visible');
						}
					}
				}
			});
			scroll(loop);
		}

		loop();

		function isElementInViewport(el) {
			var rect = el.getBoundingClientRect();
			return (
				(rect.top <= 0 && rect.bottom >= 0) || (rect.bottom >= (window.innerHeight || 
					document.documentElement.clientHeight) &&
					rect.top <= (window.innerHeight || document.documentElement.clientHeight)) ||
				(rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
			);
		}
	}

	
	updateDimensions() {
		let bgBanner
		if(window.innerWidth < 768) {
			if (this._isMounted) {
				this.setState({ 
					bgBanner: imageResponsive
				})
			}
		} else {
			bgBanner = imagePrincipal;
			if (this._isMounted) {
				this.setState({ 
					bgBanner: bgBanner
				})
			}
		}
	} 
	
	componentDidMount() {
		this._isMounted = true
		let btnDown = document.querySelectorAll('.btn-arrow'),
			secAboutUs = document.querySelectorAll('.aboutus')

		btnDown[0].addEventListener('click', () => {
			this.scrollIt(secAboutUs[0])
		});

		this.updateDimensions()

		this.getInitialElementView()

		window.addEventListener("resize", this.updateDimensions.bind(this))
		window.addEventListener("scroll", this.getElementInView.bind(this))
		this.unsubscribe_rooms = this.ref_rooms.onSnapshot(this.onCollectionUpdateRooms)
		this.unsubscribe_services = this.ref_services.onSnapshot(this.onCollectionUpdateServices)
		
	}
	componentWillUnmount() {
		this._isMounted = false
		window.removeEventListener("resize", this.updateDimensions.bind(this))
		window.removeEventListener("scroll", this.getElementInView.bind(this))
	}
	
	
	render(){

		const rooms = this.state.rooms
		const services = this.state.services
		const settings = {
			dots: true,
			infinite: true,
			lazyLoad: true,
			loop: true,
			speed: 700,
			slidesToShow: 1,
			slidesToScroll: 1,
            swipeToSlide: false,
            useCSS: false,
			initialSlide: 1,
			autoplaySpeed: 8000,
			autoplay: true
		}
		const settingservices = {
			dots: false,
			infinite: true,
			speed: 500,
			slidesToShow: 3,
			slidesToScroll: 1,
			initialSlide: 0,
			lazyLoad: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: true,
						dots: true
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						initialSlide: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		}

		return (
			<React.Fragment>
				<main id="nosotros" className="nosotros f f-ac show-on-scroll is-visible">
					<article className="gwr">
						<div className="text-mask">
							<Parallax speed={1}>
								<h2 className="parragraph--first"><span>Te enamorarás de tu estancia</span></h2> 
							</Parallax>
							<Parallax speed={1}>
								<h1 className="parragraph--second"><span>en Spring's Hotel</span></h1> 
							</Parallax>
							<Parallax speed={.6}>
								<p className="parragraph--third"><span>Hospedaje confortable, relajante y a tu medida.</span></p>
							</Parallax>
						</div>
						<Parallax speed={.6}>
						<button className="btn-arrow">
							<IconArrow color='#FFFFFF' height='32px' />
						</button>
						</Parallax>
					</article>
                	<figure className="iron-image__container">
						<img data-src={this.state.bgBanner} className="lazy iron-image iron-image--fade-in" alt="Spring's Hotel" />
					</figure>
					<Social />
				</main>
				
				<section id="nosotros" className="aboutus">
					<div className="gwr f f-ac">
						<article className="show-on-scroll">
							<Parallax speed={.72}>
								<h2>Spring's Hotel esta ubicado en el corazón de Junín, Pichanaki.</h2>
							</Parallax>
							<div className="s-wrap">
								<Parallax speed={.6}>
									<p>Nos esmeramos por ofrecer un ambiente acogedor y seguro para nuestros huéspedes, viajeros aventureros, de negocios o de placer.</p>
								</Parallax>
								<Parallax speed={.5}>
									<p>A nuestros huéspedes les brindamos una lista agencias de turísmo referidas, para que puedan planificar su estadía.</p>
								</Parallax>
							</div>
							<figure>
								<Parallax speed={1.25}> 
									<img data-src={this.state.aboutus_img} className="lazy" alt="Spring's Hotel Nosotros" />
								</Parallax>
							</figure>
						</article>
						<Parallax speed={1} className="rellax-booknow show-on-scroll">
							<div className="booknow f f-ac f-jc f-ww">
								<h2>Acojedora y relajante estadía</h2>
								<p>¡Hospedaje a tu medida!.<br/>Te enamorarás de las paradisiacas vistas de nuestra selva peruana.</p>
								<a href="www.google.com" target="_blank" className="btn">¡Reserva pronto!</a>
								
								<img data-src={this.state.bgbox1} className="lazy" alt="Acojedora y relajante estadía" />
							</div>  
						</Parallax>  
					</div>
					<Parallax speed={1.25} className="s-logo show-on-scroll">
						<img data-src={this.state.bglogo} className="lazy" alt="¡Hospedaje a tu medida!" />
					</Parallax>
				</section>
				
				<section id="rooms" className="sec-rooms show-on-scroll">
					<Parallax speed={.75} className="sec-rooms--top">
						<h2>Nuestros Dormitorios</h2>
						<p>En <b>Spring's Hotel</b> nos preocupamos por tu comodidad y bienestar, ofreciéndote servicio hotelero con dormitorios a tu medida. </p>
						<Link to={'/dormitorios'} className="btn btn-secondary">Ver todos</Link>
					</Parallax>
					<Parallax speed={.5} className="gwr" >
						<Slider {...settings}>
							{rooms.map(room =>
							<React.Fragment key={room.id}>
								<div className="room f f-ac f-jc f-ww">
									<div className="room--container">
										<div className="room__item--title f f-ac f-ww">
											<h3>{room.name}</h3>
											<strong className="f"><span>{this.state.typeMoney}</span>{room.price}</strong>
										</div>
										<p>{room.description}</p>
										<div className="room--services">
											<h4>Servicios</h4>
											<ul className="room--list f f-ww">
												{room.services.map(service =>
													(service && service.length > 0 ) ?
													<li key={service.toString()} 
														className={'icon-' + room.services.indexOf(service)}
														
													>
														<span>{service}</span>
													</li>
													:
													''
												)}
											</ul>
										</div>
									</div>
									<figure>
										<img className="lazy" src={room.image} alt={room.name} />
									</figure>
								</div>
							</React.Fragment>
							)}
						</Slider>
					</Parallax>
					<div id="services" className="services">
						<div className="gwr">
							<Parallax speed={.2} className="services--top">
								<h2>Ofrecemos</h2>
								<p>Atención cálida, rápida y cercana. Con la intención de brindar a nuestros huéspedes una agradable experiencia durante su estancia con nosotros.</p>
							</Parallax>
							<Parallax speed={.12} className="services--slider" >	
								<Slider {...settingservices}>
									{services.map(service =>
									<React.Fragment key={service.id}>
										<article>
											<h3>{service.name}</h3>
											<i className={'icon-' + service.icon} ></i>
											<img src={service.image} alt={service.name} />
										</article>
									</React.Fragment>
									)}
								</Slider>
							</Parallax>
						</div>
						<Parallax speed={1} className="box2">
							<img className="lazy" data-src={this.state.bgbox2} alt="Spring's Hotel" />
						</Parallax>
					</div>
					{/*
					<div id="tourism" className="tourism">
						<div className="gwr">
							<Parallax speed={.75} className="tourism--top">
								<h2>Turismo</h2>
								<p>Te ofrecemos un listado de zonas turísticas que tenemos en Pichanaki para que puedas disfrutar de nuestras bondades flora y fauna</p>
							</Parallax>
						</div>				
					</div>
					*/}
					
				</section>
				<Footer />
			</React.Fragment>
		)
	}
}

export default Nosotros;
